"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { classNames } from "../../utilities/props.js";
import useElementId from "../../hooks/useElementId.js";
import AccordionContext from "./Accordion.context.js";
import useHandlerRef from "../../hooks/useHandlerRef.js";
const AccordionControlled = (props) => {
    const { children, onToggle, active, iconPosition, iconSize, gap, className, attributes } = props;
    const rootClassNames = classNames(className);
    const id = useElementId();
    const onToggleRef = useHandlerRef(onToggle);
    const value = React.useMemo(() => ({
        triggerId: `${id}-trigger`,
        contentId: `${id}-content`,
        active,
        // eslint-disable-next-line react-hooks/refs
        onToggle: onToggleRef.current,
        iconPosition,
        iconSize,
        gap,
    }), [active, iconPosition, iconSize, id, onToggleRef, gap]);
    return (_jsx("div", { ...attributes, className: rootClassNames, children: _jsx(AccordionContext.Provider, { value: value, children: children }) }));
};
AccordionControlled.displayName = "AccordionControlled";
export default AccordionControlled;
